<section class="py-5 mb-5 py-md-5 py-xl-8">
  <div class="container">
    <div class="row gy-4 gy-lg-0">
      <div class="col-12 col-lg-4 col-xl-3">
        <div class="row gy-4">
          <div class="col-12">
            <div class="card main-bg-color widget-card shadow-sm">
              <!-- <div class="card-header main-bg-color">Welcome, {{ profileUserData?.username }}</div> -->
              <div class="card-body">
                <div class="text-center mb-3">
                  <div class="profile-wrapper position-relative">
                    @if(profileUserData?.image){
                    <img [src]="[profileUserData?.image]" class="me-1 profile-image rounded-circle" alt="image" />
                    }@else {
                    <img src="../../../../../../assets/customer-image/men-shadow.png"
                      class="me-1 profile-image rounded-circle" alt="image" />
                    } @if(profileUserData?.online){
                    <div class="online-indicator"></div>
                    }
                  </div>
                </div>
                <h5 class="text-center user-main-name mb-1">
                  {{ profileUserData?.username }}
                </h5>
                <p class="text-center text-secondary mb-4">
                  {{ profileUserData?.playerId }}
                </p>
                <ul class="list-group list-group-flush mb-4">
                  <li class="list-group-item main-bg-color d-flex justify-content-between align-items-center">
                    <h6 class="m-0">Name</h6>
                    <span>{{ profileUserData?.firstname }}
                      {{ profileUserData?.lastname }}</span>
                  </li>
                  <li class="list-group-item main-bg-color d-flex justify-content-between align-items-center">
                    <h6 class="m-0">Joined</h6>
                    <span>{{
                      profileUserData?.createdAt
                      | date : "dd-MMM-yyyy " : "+0000"
                      }}</span>
                  </li>
                  @if(!profileUserData?.online){
                  <li class="list-group-item main-bg-color d-flex justify-content-between align-items-center">
                    <h6 class="m-0">Last Seen</h6>
                    @if(statuShow?.username !== profileUserData?.username){
                    <span>{{ formatTimeDifference(timeDifference) }}</span>
                    }@else {
                    <span>Online</span>
                    }
                  </li>
                  }
                </ul>
                @if(statuShow?.username !== profileUserData?.username){
                <div class="d-grid m-0">
                  <button class="btn btn-outline-primary" (click)="toggleFriendRequest(profileUserData?.username)"
                    type="button">
                    {{ friendButtonLabel }}
                  </button>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card main-bg-color widget-card shadow-sm">
              <div class="card-header main-bg-color">Stats</div>
              <div class="card-body">
                <ul class="list-group list-group-flush mb-0">
                  <li class="list-group-item main-bg-color">
                    <div class="d-flex justify-content-between">
                      <h6 class="mb-1">
                        <span class="bii bi-mortarboard-fill"></span>
                        Game
                      </h6>
                      <span>{{ profileUserData?.stats.games }}</span>
                    </div>
                  </li>
                  <li class="list-group-item main-bg-color">
                    @if(statuShow.username == profileUserData?.username){
                    <div class="d-flex justify-content-between" style="cursor: pointer" (click)="puzzlePage()">
                      <h6 class="mb-1">
                        <span class="bii bi-geo-alt-fill"></span>
                        Puzzle
                      </h6>
                      <span>{{ profileUserData?.stats.puzzles }}</span>
                    </div>
                    }@else {
                    <div class="d-flex justify-content-between">
                      <h6 class="mb-1">
                        <span class="bii bi-geo-alt-fill"></span>
                        Puzzle
                      </h6>
                      <span>{{ profileUserData?.stats.puzzles }}</span>
                    </div>
                    }
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-8 col-xl-9">
        <div class="card main-bg-color widget-card shadow-sm mb-3">
          <div class="card-body p-4">
            <ul class="nav nav-tabs" id="profileTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="overview-tab" data-bs-toggle="tab"
                  data-bs-target="#overview-tab-pane" type="button" role="tab" aria-controls="overview-tab-pane"
                  aria-selected="true">
                  Overview
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane"
                  type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">
                  Completed Game
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="email-tab" data-bs-toggle="tab" data-bs-target="#email-tab-pane"
                  type="button" role="tab" aria-controls="email-tab-pane" aria-selected="false">
                  Rating
                </button>
              </li>
            </ul>
            <div class="tab-content pt-4" id="profileTabContent">
              <div class="tab-pane fade show active" id="overview-tab-pane" role="tabpanel"
                aria-labelledby="overview-tab" tabindex="0">
                <div class="mb-3 d-flex align-items-center justify-content-end">
                  @if(statuShow.username == profileUserData?.username){
                  <span>
                    <i (click)="editprofile()" data-toggle="tooltip" data-placement="bottom" title="Edit"
                      class="fa fa-light fa-pen-to-square ms-2" style="color: var(--font-color)">
                    </i>
                  </span>
                  }
                </div>

                <div class="row g-0">
                  <div class="col-5 col-md-3 main-bg-color border-bottom border-top border-color">
                    <div class="p-2">Id</div>
                  </div>
                  <div class="col-7 col-md-9 main-bg-color border-start border-bottom border-top border-color">
                    <div class="p-2">{{ profileUserData?.playerId }}</div>
                  </div>
                  <div class="col-5 col-md-3 main-bg-color border-bottom border-color">
                    <div class="p-2">Username</div>
                  </div>
                  <div class="col-7 col-md-9 main-bg-color border-start border-bottom border-color">
                    <div class="p-2">{{ profileUserData?.username }}</div>
                  </div>
                  <div class="col-5 col-md-3 main-bg-color border-bottom border-color">
                    <div class="p-2">First Name</div>
                  </div>
                  <div class="col-7 col-md-9 main-bg-color border-start border-bottom border-color">
                    <div class="p-2">{{ profileUserData?.firstname }}</div>
                  </div>
                  <div class="col-5 col-md-3 main-bg-color border-bottom border-color">
                    <div class="p-2">Last Name</div>
                  </div>
                  <div class="col-7 col-md-9 main-bg-color border-start border-bottom border-color">
                    <div class="p-2">{{ profileUserData?.lastname }}</div>
                  </div>

                  <div class="col-5 col-md-3 main-bg-color border-bottom border-color">
                    <div class="p-2">Status</div>
                  </div>
                  <div class="col-7 col-md-9 main-bg-color border-start border-bottom border-color">
                    <div class="p-2">{{ profileUserData?.status || "-" }}</div>
                  </div>
                  <!-- <div class="col-5 col-md-3 main-bg-color border-bottom border-color border-3">
                    <div class="p-2">Last Online</div>
                  </div>
                  <div class="col-7 col-md-9 main-bg-color border-start border-bottom border-color border-3">
                    <div class="p-2">{{ profileUserData?.lastOnline }}</div>
                  </div> -->
                </div>
              </div>
              <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab"
                tabindex="0">
                <select class="form-select ms-auto w-25 mb-2" style="height: 40px" (change)="onChange($event)">
                  @for(games of devices; track $index){
                  <option>{{ games }}</option>
                  }
                </select>
                <div class="row gy-3 gy-xxl-4">
                  <div class="col-12">
                    <div [ngClass]="customclassprofileBoard" (scroll)="onScroll($event)">
                      <table class="table mb-0">
                        <thead>
                          <tr class="table-header table-header-sticky">
                            <th class="col-2">Black</th>
                            <th class="col-2">White</th>
                            <th class="col-2">Winner</th>
                            <th class="col-2">WonBY</th>
                            <th class="col-2">Time</th>
                            <th class="col-2 text-nowrap">
                              Date @if(SortDate == 'descendingDate'){
                              <i class="fa-solid fa-arrow-up" data-toggle="tooltip" data-placement="top"
                                title="Ascending Date" (click)="ascendingDate('ascendingDate')"></i>
                              } @else if(SortDate == 'ascendingDate'){
                              <i class="fa-solid fa-arrow-down" data-toggle="tooltip" data-placement="top"
                                title="Descending Date" (click)="descendingDate('descendingDate')"></i>
                              }
                            </th>
                          </tr>
                        </thead>
                        <tbody class="border" style="cursor: pointer">
                          @if(lastGamehistroy.length == 0) {
                          <tr>
                            <td colspan="7">
                              <div class="d-flex justify-content-center">
                                <p class="text-white m-0">No game Record's.</p>
                              </div>
                            </td>
                          </tr>
                          }@else{ @for(games of lastGamehistroy; track $index){
                          <tr (click)="gameHistory(games._id)">
                            <td>
                              <p class="m-0 text-nowrap">
                                {{ games.blackSidePlayer }}
                              </p>
                            </td>
                            <td>
                              <p class="m-0 text-nowrap">
                                {{ games.whiteSidePlayer }}
                              </p>
                            </td>
                            <td>
                              @if(games.winner){
                              <p class="m-0 text-nowrap">{{ games.winner }}</p>
                              }@else {
                              <p class="m-0">-</p>
                              }
                            </td>
                            <td>
                              <p class="m-0">{{ games.wonBY }}</p>
                            </td>
                            <td>
                              <p class="m-0 text-nowrap">{{ games.time }}</p>
                            </td>
                            <td>
                              <p class="m-0 text-nowrap">
                                {{
                                games.date | date : "dd-MMM-yyyy " : "+0000"
                                }}
                              </p>
                            </td>
                          </tr>
                          } @if(isLoading){
                          <tr>
                            <td colspan="7">
                              <div class="d-flex justify-content-center">
                                <p class="loader ms-3 m-0"></p>
                              </div>
                            </td>
                          </tr>
                          } }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="email-tab-pane" role="tabpanel" aria-labelledby="email-tab" tabindex="0">
                <div class="row gy-3 gy-xxl-4">
                  @for (chart of charts; track $index) {
                  <div class="col-md-6 rating-section">
                    <div class="m-1">
                      <div class="d-flex align-items-center">
                        <div class="">
                          <img style="width: 25px; height: 25px" [src]="
                              '/assets/icon-image/' +
                              chart.title.toLowerCase() +
                              '-img.svg'
                            " alt="image" />
                        </div>
                        <div class="ms-2">
                          <h6 class="Games-text mb-0">{{ chart.title }}</h6>
                        </div>
                      </div>
                      <ng-container>
                        <canvas #chartCanvas></canvas>
                      </ng-container>
                    </div>
                    @if (chart.title == 'Rapid' || chart.title == 'Bullet'
                    ||chart.title == 'Blitz') {
                    <div class="d-flex justify-content-between align-items-center mt-2 p-2 rating-games rounded">
                      <div class="text-center">
                        <p class="m-0">Win</p>
                        <p class="m-0">
                          {{ chart.win }}
                        </p>
                      </div>
                      <div class="text-center">
                        <p class="m-0">Loss</p>
                        <p class="m-0">
                          {{ chart.lost }}
                        </p>
                      </div>
                      <div class="text-center">
                        <p class="m-0">Draw</p>
                        <p class="m-0">
                          {{ chart.draw }}
                        </p>
                      </div>
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card widget-card main-bg-color shadow-sm">
          <div class="card-header main-bg-color">
            Friends @if(statuShow.username == profileUserData?.username){
            <button class="right-arrow-btn" data-toggle="tooltip" data-placement="bottom" title="Friends"
              (click)="friendlist()">
              <i class="fa fa-solid fa-angle-right"></i>
            </button>
            }
          </div>
          <div class="card-body profile-friend-box">
            @if(friends.length > 0){
            @for(friend of friends;track $index){
            <div style="position: relative; display: inline-block;">
              <img data-toggle="tooltip" data-placement="bottom" title="{{ friend.username }}"
                (click)="friendprofile(friend.username)"
                [src]="friend.image ? friend.image : '../../../../../../assets/customer-image/men-shadow.png'"
                class="ms-1 profile-friend-image" alt="image" />
              @if(friend.online){
              <div class="green_dot"></div>
              }
            </div>
            }
            }@else {
            <div class="text-center">
              @if(statuShow.username == profileUserData?.username){
              <p class="mb-0" style="color: grey">
                No friends here yet! Let's change that – add some friends now!
              </p>
              }@else{
              <p class="mb-0" style="color: grey">
                player's friend list is empty.
              </p>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>